import { ArrowUpRight, KeyRound, ScrollText, UsersRound } from "lucide-react";
import { Link } from "react-router-dom";
import { defaultAdminNavigation } from "../../app/navigation";
import { NavigationSearch } from "../../shared/components/NavigationSearch";
import { useAuth } from "../auth/auth-context";

export function DashboardPage() {
  const { operator } = useAuth();
  return (
    <div className="mx-auto max-w-6xl">
      <section className="mx-auto max-w-2xl pb-12 pt-4 text-center sm:pb-16 sm:pt-10">
        <span className="inline-flex items-center gap-2 text-xs text-muted-foreground">
          <span className="size-1.5 rounded-full bg-orange-500" aria-hidden="true" /> Central de operações
        </span>
        <h1 className="mt-6 text-3xl font-semibold tracking-tight sm:text-[34px]">Administração do Gunbound</h1>
        <p className="mb-7 mt-3 text-sm text-muted-foreground">Gerencie jogadores, conteúdo e operações do jogo.</p>
        <NavigationSearch large />
      </section>
      <section aria-label="Áreas administrativas" className="grid gap-9 md:grid-cols-3 md:gap-7">
        {defaultAdminNavigation.filter((group) => group.label).map((group) => (
          <div key={group.label}>
            <h2 className="mb-3 px-2 text-xs font-medium text-muted-foreground">{group.label}</h2>
            <div className="divide-y">
              {group.items.map((item) => (
                <Link to={item.to} key={item.to} className="group flex min-h-[76px] items-center gap-3 rounded-sm px-2 py-4 transition-colors hover:bg-muted">
                  <item.icon className="size-[18px] shrink-0 text-muted-foreground" strokeWidth={1.5} aria-hidden="true" />
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-medium">{item.label}</span>
                    <span className="mt-1 block text-xs leading-5 text-muted-foreground">{item.description}</span>
                  </span>
                  <ArrowUpRight className="size-3.5 shrink-0 text-muted-foreground group-hover:text-primary" aria-hidden="true" />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </section>
      <section aria-labelledby="daily-actions" className="mt-14 border-t pt-8 sm:mt-16">
        <div className="mb-5 flex items-center justify-between gap-3">
          <h2 id="daily-actions" className="text-sm font-semibold">No dia a dia</h2>
          <span className="text-xs text-muted-foreground">Acesso rápido</span>
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          <Shortcut to="/jogadores" icon={UsersRound} title="Encontrar um jogador" description="Consulte contas, perfis e saldos." action="Pesquisar jogadores" />
          <Shortcut to="/auditoria" icon={ScrollText} title="Acompanhar operações" description="Consulte o histórico de ações da equipe." action="Ver auditoria" />
          <Shortcut to="/acessos/roles" icon={KeyRound} title="Consultar permissões" description="Confira os acessos administrativos." action="Ver roles" />
        </div>
      </section>
      <footer className="mt-12 flex flex-wrap items-center justify-between gap-2 border-t pt-5 text-xs text-muted-foreground">
        <span>Gunbound Admin</span><span className="min-w-0 break-all">{operator?.email}</span>
      </footer>
    </div>
  );
}
function Shortcut({ to, icon: Icon, title, description, action }: {
  to: string; icon: typeof UsersRound; title: string; description: string; action: string;
}) {
  return (
    <Link to={to} className="group flex flex-col rounded-lg border bg-card p-5 transition-colors hover:border-zinc-400 dark:hover:border-zinc-500">
      <Icon className="mb-4 size-5 text-muted-foreground" strokeWidth={1.5} aria-hidden="true" />
      <h3 className="text-sm font-medium">{title}</h3>
      <p className="mt-2 flex-1 text-xs leading-5 text-muted-foreground">{description}</p>
      <span className="mt-5 inline-flex items-center gap-1 text-xs font-medium text-primary">{action}<ArrowUpRight className="size-3.5" aria-hidden="true" /></span>
    </Link>
  );
}
